import React, { useState } from 'react';
import { supabase } from '../../../lib/supabase/client';
import { Check, CircleNotch, EnvelopeSimple, X } from '@phosphor-icons/react';
import { DialogHuelle, ImmoButton, SchalterZeile } from '../../../components/immobilien/ui';
import { FELD, Feld } from './bereich/Formular';

// Edit-only: Das eine Graph-Postfach kann umbenannt werden; die E-Mail-Adresse ist der
// Schlüssel zur GRAPH_MAILBOX-Konfiguration und bleibt deshalb nur lesend.
interface EmailKontoFormularProps {
  konto: any;
  onClose: () => void;
  onSaved: () => void;
}

const EmailKontoFormular: React.FC<EmailKontoFormularProps> = ({ konto, onClose, onSaved }) => {
  const [bezeichnung, setBezeichnung] = useState(konto?.bezeichnung || '');
  const [absenderName, setAbsenderName] = useState(konto?.absender_name || '');
  const [istStandard, setIstStandard] = useState(konto?.ist_standard || false);
  const [saving, setSaving] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  const handleSave = async () => {
    if (!bezeichnung.trim()) return;
    setSaving(true);
    setFehler(null);
    try {
      const { error } = await supabase
        .from('email_konten')
        .update({ bezeichnung: bezeichnung.trim(), absender_name: absenderName.trim() || null, ist_standard: istStandard })
        .eq('id', konto.id);
      if (error) throw error;
      onSaved();
    } catch (err: any) {
      console.error('Fehler beim Speichern:', err);
      setFehler(err?.message || 'Speichern fehlgeschlagen.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <DialogHuelle
      titel="E-Mail-Konto bearbeiten"
      untertitel="Angebunden über Microsoft 365 (Graph)"
      icon={EnvelopeSimple}
      breite={480}
      laeuft={saving}
      onSchliessen={onClose}
      fuss={
        <div className="flex justify-end w-full" style={{ gap: 8 }}>
          <ImmoButton groesse={44} icon={X} onClick={onClose} disabled={saving}>Abbrechen</ImmoButton>
          <ImmoButton art="akzent" groesse={44} icon={saving ? CircleNotch : Check} onClick={handleSave} disabled={!bezeichnung.trim() || saving}>Speichern</ImmoButton>
        </div>
      }
    >
      {fehler && (
        <div role="alert" style={{ borderRadius: 14, padding: '10px 14px', background: 'var(--bad-soft)', color: 'var(--bad)', fontSize: 13, fontWeight: 700 }}>{fehler}</div>
      )}
      <Feld label="E-Mail-Adresse" hinweis="Die Adresse ist über die Graph-Anbindung festgelegt und kann hier nicht geändert werden.">
        <input value={konto?.email_adresse ?? ''} readOnly style={{ ...FELD, opacity: 0.6 }} />
      </Feld>
      <Feld label="Bezeichnung *" hinweis="Interne Bezeichnung (nur in dieser App sichtbar).">
        <input type="text" value={bezeichnung} onChange={(e) => setBezeichnung(e.target.value)} placeholder='z.B. "Firmenkonto"' style={FELD} />
      </Feld>
      <Feld label="Absender-Name" hinweis="So erscheint der Absender beim Empfänger. Leer = Standardname des Postfachs (Microsoft 365).">
        <input type="text" value={absenderName} onChange={(e) => setAbsenderName(e.target.value)} placeholder='z.B. "Immobilienmanagement Schwede"' style={FELD} />
      </Feld>
      <SchalterZeile an={istStandard} onChange={setIstStandard} label="Als Standard-Konto verwenden" />
    </DialogHuelle>
  );
};

export default EmailKontoFormular;
